import React, { Component } from "react"

export default class Aptitbooks extends Component {
  render() {
  return (
    <div className="aptitoptions">
      <a href="https://en.wikipedia.org/wiki/Nostalgia_(novel)" target="_blank" rel="noopener noreferrer"><p className="apatitentry">&bull; Nostalgia</p></a>
      <a href="https://en.wikipedia.org/wiki/L%C3%A0-bas_(novel)"target="_blank" rel="noopener noreferrer"><p className="apatitentry">&bull; The Damned La-bas</p></a>
      <a href="https://en.wikipedia.org/wiki/Coin_Locker_Babies" target="_blank" rel="noopener noreferrer"><p className="apatitentry">&bull; Coin Locker Babies</p></a>
      <a href="https://en.wikipedia.org/wiki/The_Trial" target="_blank" rel="noopener noreferrer"><p className="apatitentry">&bull; The Trial</p></a>
      <a href="https://en.wikipedia.org/wiki/Cat%27s_Cradle" target="_blank" rel="noopener noreferrer"><p className="apatitentry">&bull; Cat's Cradle</p></a>
      <a href="https://en.wikipedia.org/wiki/Roadside_Picnic" target="_blank" rel="noopener noreferrer"><p className="apatitentry">&bull; Roadside Picnic</p></a>
      <a href="https://en.wikipedia.org/wiki/The_Master_and_Margarita" target="_blank" rel="noopener noreferrer"><p className="apatitentry">&bull; The Master and Margarita</p></a>
      <a href="https://books.google.ch/books/about/Zenobia.html?id=vohiAAAAMAAJ&source=kp_book_description&redir_esc=y" target="_blank" rel="noopener noreferrer"><p className="apatitentry">&bull; Zenobia</p></a>
    </div>
  )
}
}

